// Toggle the presence of a value in an array
export function arrayChange(value, array) {
    if (array.includes(value)) {
        return [...array.filter((n) => n !== value)];
    }
    return [...array, value];
}
export function chunkArray(array, size) {
    if (array.length <= size) {
        return [array];
    }
    return [array.slice(0, size), ...chunkArray(array.slice(size), size)];
}
